import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';
import { URLS_CONST } from 'src/app/shared/constants/url-constants';


@Injectable({
  providedIn: 'root'
})
export class AccountsService {
  private accountIDSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private projectIDSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');

  private brandDetailsSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public brandDetails$ = this.brandDetailsSubject.asObservable();



  setBrandDetails(details: any): void {
    this.brandDetailsSubject.next(details);
  }
  
  constructor(private http: HttpClient,
    public _utilService: UtilsService
  ) { }

  setAccountID(accountID: string) {
    this.accountIDSubject.next(accountID);
  }

  getAccountID(): Observable<string> {
    return this.accountIDSubject.asObservable();
  }

  getAccounts(manager_id: string) {
    const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.accountDataByManagerIdV2)
    const params: any = {}
    params[URLS_CONST.MANAGER_ID] = manager_id
    return this._utilService.getAPICall(url, this._utilService.setHeaderWithParams(params))
  }
  getAccountDetail(account_id: string) {
    const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.accountDataById)
    const params: any = {}
    params[URLS_CONST.ACCOUNT_ID] = account_id
    return this._utilService.getAPICall(url, this._utilService.setHeaderWithParams(params))
  }

  getAccountManagersByAccountId(account_id: string, limit: number, page_number: number) {
    const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.accountManagersByAccountId)
    const params: any = {}
    params[URLS_CONST.ACCOUNT_ID] = account_id
    params[URLS_CONST.LIMIT] = limit
    params[URLS_CONST.PAGE_NUMBER] = page_number
    return this._utilService.getAPICall(url, this._utilService.setHeaderWithParams(params))
  }

  getBrandDetail(brand_id: string) {
    const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.brandsDataById)
    const params: any = {}
    params[URLS_CONST.BRAND_ID] = brand_id
    return this._utilService.getAPICall(url, this._utilService.setHeaderWithParams(params))
  }
  
  getBrandsList(account_id:any){
    const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.brandsDataByList)
    const params: any = {}
    params[URLS_CONST.ACCOUNT_ID] = account_id
    params.limit = 1200 // temporary getting max 30 project
    return this._utilService.getAPICall(url, this._utilService.setHeaderWithParams(params))
  }

  // This service is prepared for the updated brands configurations
  updateBrandsConfiguration(brand_id, reqBody) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.updateBrandsConfiguration);
      const params: any = {}
      params[URLS_CONST.BRAND_ID] = brand_id
      return this._utilService.putAPICall(url, reqBody, this._utilService.setHeaderWithParams(params))
    } catch (error) {
      console.error('An unexpected error occurred in updateBrandsConfiguration:', error);
      // Add your error handling logic for unexpected errors here
      return throwError('An unexpected error occurred'); // You can customize the error message as needed
    }
  }

    // This service is prepared for the updated accounts configurations
    updateAccountsConfiguration(account_id, reqBody) {
      try {
        const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.updateAccountsConfiguration);
        const params: any = {}
        params[URLS_CONST.ACCOUNT_ID] = account_id
        return this._utilService.putAPICall(url, reqBody, this._utilService.setHeaderWithParams(params))
      } catch (error) {
        console.error('An unexpected error occurred in updateAccountsConfiguration:', error);
        // Add your error handling logic for unexpected errors here
        return throwError('An unexpected error occurred'); // You can customize the error message as needed
      }
    }

  getFeedListPost(reqBody) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.feedList);
      return this._utilService.postAPICall(url, reqBody, this._utilService.setHeaders())
    } catch (error) {
      console.error('An unexpected error occurred in getFeedListPost:', error);
      return throwError('An unexpected error occurred in getFeedListPost');
    }
  }
  getModulConfigs(params: any) {
    const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.moduleConfigs)
    return this._utilService.getAPICall(url, this._utilService.setHeaderWithParams(params))
  }

  // check if this account is permitted for LW3 dashboard or not
  isLw3PermittedAccount(account_details){
    if (environment && environment['is_lw3_permitted_account'] && environment['is_lw3_permitted_account'] == true) {
      if (account_details && account_details['is_lw3_permitted_account'] && account_details['is_lw3_permitted_account'] == true) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  createAccount(requestBody: any) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.createAccount);
      return this._utilService.postAPICall(url, requestBody, this._utilService.setHeaders());
    } catch (error) {
      console.error('An unexpected error occurred in createAccount:', error);
      return throwError('An unexpected error occurred in createAccount');
    }
  }
  
  /**
   * Create a new brand/project
   * @param projectData - Object containing brand_name, account_id, timezone, g_recaptcha_response, etc.
   * @returns Observable with the created brand response
   */
  createBrand(projectData: any): Observable<any> {
    const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, '/brands/create');
    return this._utilService.postAPICall(url, projectData, this._utilService.setHeaders());
  }

  /**
   * Create Litmus Jobs for cloning project 
   * @param cloneData - Object containing brand_id, job_type, and parameters
   * @returns Observable with the job creation response
   */
  createLitmusJobs(cloneData: any): Observable<any> {
    console.log(cloneData);
    
    const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, '/jobs/create');
    return this._utilService.postAPICall(url, cloneData, this._utilService.setHeaders());
  }

  /**
   * Add a new account manager 
   * @param managerData - Object containing first_name, last_name, email_address, account_id, etc.
   * @returns Observable with the created manager response
   */
  addAccountManager(managerData: any): Observable<any> {
    const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, '/managers/register_manager_profile_v2');
    return this._utilService.postAPICall(url, managerData, this._utilService.setHeaders());
  }

  /**
   * Revoke manager access 
   * @param revokeData - Object containing admin_manager_id, email_address, type, account_id or brand_id
   * @returns Observable with the revoke response
   */
  revokeManagerAccess(revokeData: any): Observable<any> {
    const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, '/managers/revoke_manager_access');
    return this._utilService.putAPICall(url, revokeData, this._utilService.setHeaders())
  }

}
